<template>
  <div id="Chart">
    <div class="side first">
      <div class="side__row topRow">
        <div class="item"></div>
        <div class="item white">before deadline</div>
        <div class="item black">after deadline</div>
      </div>
      <template v-for="(group, index) in chartData">
        <div
          class="side__row titleRow"
          :key="'group' + index"
          v-if="group.side === 'left' && group.titleRow"
        >
          <div class="item black">
            &nbsp;&nbsp;&nbsp;&nbsp;{{ group.title }}
          </div>
          <div class="item white">full season</div>
          <div class="item white">half season</div>
          <div class="item black">full season</div>
          <div class="item black">half season</div>
        </div>
        <div
          class="side__row titleRow"
          :key="'group' + index"
          v-else-if="group.side === 'left'"
        >
          <div class="item black">
            &nbsp;&nbsp;&nbsp;&nbsp;{{ group.title }}
          </div>
          <div class="item white"></div>
          <div class="item white"></div>
          <div class="item black"></div>
          <div class="item black"></div>
        </div>
        <template v-if="group.side === 'left'">
          <div
            class="side__row contentRow"
            v-for="(section, ind) in group.sectionData"
            :key="'content' + ind"
          >
            <div class="item black" :class="{ borderGradient: section.border }">
              <div
                class="hex"
                :style="{ 'background-color': section.hex }"
                v-if="!section.lines"
              ></div>
              <div
                class="hex"
                :style="{
                  background: `repeating-linear-gradient(155deg, ${section.hex}, #3a4038 5px, ${section.hex} 6px, #3a4038 5px)`,
                }"
                v-else
              ></div>
              {{ section.title }}
            </div>
            <div class="item white" :class="{ whiteBorder: section.border }">
              ${{ currency(section.beforeFull) }}
            </div>
            <div class="item white" :class="{ whiteBorder: section.border }">
              ${{ currency(section.beforeHalf) }}
            </div>
            <div class="item black" :class="{ blackBorder: section.border }">
              ${{ currency(section.afterFull) }}
            </div>
            <div class="item black" :class="{ blackBorder: section.border }">
              ${{ currency(section.afterHalf) }}
            </div>
          </div>
        </template>
      </template>
      <div class="mobile-side">
        <template v-for="(group, index) in chartData">
          <div
            class="side__row titleRow"
            :key="'group' + index"
            v-if="group.side === 'right' && group.titleRow"
          >
            <div class="item black">
              &nbsp;&nbsp;&nbsp;&nbsp;{{ group.title }}
            </div>
            <div class="item white">full season</div>
            <div class="item white">half season</div>
            <div class="item black">full season</div>
            <div class="item black">half season</div>
          </div>
          <div
            class="side__row titleRow"
            :key="'group' + index"
            v-else-if="group.side === 'right'"
          >
            <div class="item black">
              &nbsp;&nbsp;&nbsp;&nbsp;{{ group.title }}
            </div>
            <div class="item white"></div>
            <div class="item white"></div>
            <div class="item black"></div>
            <div class="item black"></div>
          </div>
          <template v-if="group.side === 'right'">
            <div
              class="side__row contentRow"
              v-for="(section, ind) in group.sectionData"
              :key="'content' + ind"
            >
              <div
                class="item black"
                :class="{ borderGradient: section.border }"
              >
                <div
                  class="hex"
                  :style="{ 'background-color': section.hex }"
                  v-if="!section.lines"
                ></div>
                <div
                  class="hex"
                  :style="{
                    background: `repeating-linear-gradient(155deg, ${section.hex}, #3a4038 5px, ${section.hex} 6px, #3a4038 5px)`,
                  }"
                  v-else
                ></div>
                {{ section.title }}
              </div>
              <div class="item white" :class="{ whiteBorder: section.border }">
                ${{ currency(section.beforeFull) }}
              </div>
              <div class="item white" :class="{ whiteBorder: section.border }">
                ${{ currency(section.beforeHalf) }}
              </div>
              <div class="item black" :class="{ blackBorder: section.border }">
                ${{ currency(section.afterFull) }}
              </div>
              <div class="item black" :class="{ blackBorder: section.border }">
                ${{ currency(section.afterHalf) }}
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
    <div class="side second">
      <div class="side__row topRow">
        <div class="item"></div>
        <div class="item white">before deadline</div>
        <div class="item black">after deadline</div>
      </div>
      <template v-for="(group, index) in chartData">
        <div
          class="side__row titleRow"
          :key="'group' + index"
          v-if="group.side === 'right' && group.titleRow"
        >
          <div class="item black">
            &nbsp;&nbsp;&nbsp;&nbsp;{{ group.title }}
          </div>
          <div class="item white">full season</div>
          <div class="item white">half season</div>
          <div class="item black">full season</div>
          <div class="item black">half season</div>
        </div>
        <div
          class="side__row titleRow"
          :key="'group' + index"
          v-else-if="group.side === 'right'"
        >
          <div class="item black">
            &nbsp;&nbsp;&nbsp;&nbsp;{{ group.title }}
          </div>
          <div class="item white"></div>
          <div class="item white"></div>
          <div class="item black"></div>
          <div class="item black"></div>
        </div>
        <template v-if="group.side === 'right'">
          <div
            class="side__row contentRow"
            v-for="(section, ind) in group.sectionData"
            :key="'content' + ind"
          >
            <div class="item black" :class="{ borderGradient: section.border }">
              <div
                class="hex"
                :style="{ 'background-color': section.hex }"
                v-if="!section.lines"
              ></div>
              <div
                class="hex"
                :style="{
                  background: `repeating-linear-gradient(155deg, ${section.hex}, #3a4038 5px, ${section.hex} 5px, #3a4038 5px)`,
                }"
                v-else
              ></div>
              {{ section.title }}
            </div>
            <div class="item white" :class="{ whiteBorder: section.border }">
              ${{ currency(section.beforeFull) }}
            </div>
            <div class="item white" :class="{ whiteBorder: section.border }">
              ${{ currency(section.beforeHalf) }}
            </div>
            <div class="item black" :class="{ blackBorder: section.border }">
              ${{ currency(section.afterFull) }}
            </div>
            <div class="item black" :class="{ blackBorder: section.border }">
              ${{ currency(section.afterHalf) }}
            </div>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { chartData } from "./chartData";

export default {
  name: "Chart",
  data() {
    return {
      chartData: chartData(),
    };
  },
  methods: {
    currency(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style lang="scss" scoped>
#Chart {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  @media (max-width: 480px) {
    max-width: 100%;
    overflow: scroll;
  }
  .side {
    display: flex;
    flex-direction: column;
    width: calc(50% - 17px);
    &.first {
      @media (max-width: 992px) {
        width: 100%;
      }
      @media (max-width: 480px) {
        width: 465px;
        min-width: 465px;
      }
    }
    &.second {
      @media (max-width: 992px) {
        display: none;
      }
    }
    .mobile-side {
      @media (min-width: 992px) {
        display: none;
      }
    }
    &__row {
      display: flex;
      flex-direction: row;
      &.topRow {
        .item {
          flex: 1;
          padding-top: 17px;
          &:first-child {
            flex: 2;
          }
        }
      }
      &.titleRow {
        .item {
          padding: 15px 0 10px 0;
        }
      }
      &.topRow,
      &.titleRow {
        font-family: DINPro-CondBlack;
        font-weight: 900;
        font-size: 12px;
        line-height: 15px;
        letter-spacing: normal;
        text-transform: uppercase;
        color: #ffffff;
        text-align: center;
        .white {
          color: #000000;
        }
      }
      &.contentRow {
        position: relative;
        font-family: DINPro-CondBlack;
        font-weight: 900;
        font-size: 13px;
        line-height: 17px;
        letter-spacing: normal;
        text-transform: uppercase;
        color: #ffffff;
        text-align: center;
        .white {
          color: #000000;
        }
      }
      .item {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
        &:first-child {
          justify-content: flex-start;
          flex: 4;
        }
        &.white {
          background-color: #ffffff;
          // box-shadow: 0 6px 30px 0 #000000;
        }
        &.black {
          // background-color: #161616;
          background-color: #000000;
          // box-shadow: 0 6px 30px 0 #000000;
        }
        &.borderGradient {
          border-top: 1px solid;
          border-left: 0;
          border-right: 0;
          border-bottom: 0;
          border-image-slice: 1;
          border-image-source: linear-gradient(
            328.87deg,
            #3e3e3e 0%,
            rgba(62, 62, 62, 0) 100%
          );
        }
        &.whiteBorder {
          border-top: 1px solid #ececec;
        }
        &.blackBorder {
          border-top: 1px solid #232323;
        }
        .hex {
          position: relative;
          height: 26px;
          width: 12px;
          border-radius: 2px;
          margin-right: 5px;
          overflow: hidden;
        }
      }
    }
  }
}
</style>